<template>
  <div class="form-group row mt-3">
    <label class="col-sm-2 text-sm-right">Sigla Orgão:</label>
    <auto-complete-comp
      class="col-md-3 col-sm-10 mb-3"
      :isAsync="true"
      :url="autocomplete.url"
      mutation="MUT_FILTRO_DESTINATARIO_DEPARTAMENTO"
      keyAttrName="estruturaID"
      valueAttrName="siglaEstrutura"
      :valor="filtro.codHierarquia">
    </auto-complete-comp>

    <label class="col-sm-2 text-sm-right">Sigla Departamento:</label>
    <div class="col-md-4 col-sm-11 mb-3">
      <input
        type="text"
        class="form-control"
        id="inputDepartamento"
        placeholder="informe o departamento"
        v-model="filtro.siglaEstrutura"
        :disabled="habilitarCampos == 1"
      />
    </div>

    <label class="col-sm-2 text-sm-right">Nome Gestor:</label>
    <div class="col-md-3 col-sm-11 mb-3">
      <input
        type="text"
        class="form-control"
        id="inputGestor"
        placeholder="informe o nome do gestor"
        v-model="filtro.nomeGestor"
        :disabled="habilitarCampos == 1"
      />
    </div>

    <label class="col-sm-2 text-sm-right">Cidade:</label>
    <div class="col-md-4 col-sm-11 mb-3">
      <input
        type="text"
        class="form-control"
        id="inputCidade"
        placeholder="informe a cidade"
        v-model="filtro.cidade"
        :disabled="habilitarCampos == 1"
        />
    </div>

    <div class="col-sm-12">
      <div class="row btnAcoes">
        <div class="col-1"></div>
        <button class="btn btn-outline-success" @click.prevent="() => consultar()"> Pesquisar </button>
        <button class="btn btn-outline-danger" @click.prevent="limpar"> Limpar </button>
      </div>
    </div>
  </div>
</template>

<script>
import DadosFixosService from '@/services/DestinatarioService'
import autoCompleteComp from '@/components/autocomplete/AutoCompleteComp'
import eventBus from '@/uteis/eventBus'

export default {
  components: {
    autoCompleteComp
  },

  props: {
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String },
    acceptUserDepartamento: { required: false, type: Boolean, default: false }
  },

  data () {
    return {
      autocomplete: {
        url: '/d0593/pae-back/v1/participantes/estrutura',
        eventOrgao: 'filtroDepartamentoDestinatario'
      },
      filtro: {
        codHierarquia: null,
        siglaEstrutura: null,
        nomeGestor: null,
        cidade: null,
        idDepartamento: null,
        range: 5
      },
      columns: [
        [
          { key: 'nomeEstrutura', title: 'Nome' },
          { key: 'siglaEstrutura', title: 'Sigla' },
          { key: 'tipoContatoExterno', title: 'Tipo', converter: 'tipoContatoExterno' }
        ], [
          { key: 'estruturaID', title: 'Identificador' },
          { key: 'cidadeEstado', title: 'Cidade' }
        ], [
          { key: 'nomeUsuario', title: 'Gestor' },
          { key: 'telefone', title: 'Telefone' }
        ]
      ],
      disabled: 1
    }
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.consultar(numeroPagina)
    })

    eventBus.$on(this.autocomplete.eventOrgao, (orgao) => {
      this.filtro.codHierarquia = orgao.codigoHierarquia
    })

    if (!this.acceptUserDepartamento) {
      this.filtro.idDepartamento = this.$store.getters.getDadosSessao.sessao.idDepartamento
    }
    this.service = new DadosFixosService()
  },

  destroyed () {
    eventBus.$off(this.autocomplete.eventOrgao)
  },

  methods: {
    consultar (page = 1) {
      this.filtro = {
        ...this.filtro,
        offset: page
      }

      this.service.buscarDepartamento(this.filtro).then(res => {
        const departamentos = res.data.data.map((departamento) => {
          return {
            tipoContatoExterno: 'Poder Executivo Estadual',
            ...departamento,
            cidadeEstado: `${departamento.estado} / ${departamento.cidade}`
          }
        })
        eventBus.$emit(this.eventBusDataName, {
          data: departamentos,
          pagination: res.data.pagination,
          id: 'estruturaID',
          columns: this.columns
        })
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      this.filtro = {
        ...this.filtro,
        codigoHierarquia: null,
        siglaEstrutura: null,
        nomeGestor: null,
        cidade: null
      }
      this.consultar()
    }

  },
  computed: {
    habilitarCampos () {
      let retorno = 0
      if (!this.filtro.codHierarquia) {
        retorno = 1
      } else {
        retorno = 0
      }
      return retorno
    }
  }
}
</script>
